import { Link } from "react-router-dom"

type HeroProps = {
  onPrimaryCta: () => void
  onLogin: () => void
}

export const Hero = ({ onPrimaryCta, onLogin }: HeroProps) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-850 via-slate-900 to-brand-700 text-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <div className="max-w-3xl">
          <p className="mb-4 inline-flex rounded-full bg-white/10 px-3 py-1 text-xs font-medium uppercase tracking-wide text-brand-100">
            Motor fiscal SaaS
          </p>
          <p className="mb-4 inline-flex rounded-full bg-emerald-500/20 px-3 py-1 text-xs font-medium uppercase tracking-wide text-emerald-100">
            NFe homologada
          </p>
          <h1 className="text-4xl font-bold leading-tight sm:text-5xl">
            Motor fiscal SaaS para quem não pode errar na NFe
          </h1>
          <p className="mt-5 text-lg text-slate-200 sm:text-xl">
            API REST assíncrona, painel multiempresa e auditoria total — um hub confiável para ERPs,
            e-commerces e contadores.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={onPrimaryCta}
              className="rounded-lg bg-white px-5 py-3 text-sm font-semibold text-brand-700 transition hover:bg-brand-50"
            >
              Começar agora
            </button>
            <button
              type="button"
              onClick={onLogin}
              className="rounded-lg border border-white/30 px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
            >
              Entrar no painel
            </button>
            <Link
              to="/desenvolvedores"
              className="rounded-lg border border-white/30 px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
            >
              Documentação API
            </Link>
          </div>
        </div>
        <p className="mt-10 text-sm text-slate-300">
          FiscalHub · multi-CNPJ · homologação e produção · LGPD by design
        </p>
      </div>
    </section>
  )
}
